import { render, staticRenderFns } from "./FooterSdiSshi.vue?vue&type=template&id=ea41169e&scoped=true"
import script from "./FooterSdiSshi.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterSdiSshi.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FooterSdiSshi.vue?vue&type=style&index=0&id=ea41169e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea41169e",
  null
  
)

export default component.exports